module.exports = __webpack_public_path__ + "catalog/items/firesafety/Fire-Door-FD30/Fire-Door-FD30.svg";